var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "boss-vertical-menu-item",
      class: { "is-selected": _vm.isSelected },
      on: { click: _vm.show },
    },
    [
      _c(
        "div",
        {
          directives: [
            {
              name: "tooltip",
              rawName: "v-tooltip",
              value: {
                content:
                  "新しく会員がヒットした場合にお知らせする検索条件を、３つ選択できます。",
              },
              expression:
                "{ content: '新しく会員がヒットした場合にお知らせする検索条件を、３つ選択できます。'}",
            },
          ],
          staticClass: "pega-fav-icon",
          attrs: { "data-test": "fav-icon" },
          on: {
            click: function ($event) {
              $event.stopPropagation()
              return _vm.$emit(
                "updateOften",
                _vm.searchCondition.id,
                _vm.searchCondition.isOftenUse
              )
            },
          },
        },
        [
          _c("span", {
            staticClass: "boss-icon",
            class: [
              _vm.searchCondition.isOftenUse
                ? "boss-icon-bell-solid"
                : "boss-icon-bell-regular",
            ],
            attrs: { "data-test": "icon" },
          }),
        ]
      ),
      _vm._v(" "),
      _c(
        "span",
        {
          staticClass: "pega-break",
          attrs: {
            "data-test": "search-condition-name-" + _vm.searchCondition.id,
          },
        },
        [_vm._v(_vm._s(_vm.searchCondition.name))]
      ),
      _vm._v(" "),
      _vm.searchCondition.isNew
        ? _c(
            "span",
            { staticClass: "boss-notify-count", attrs: { "data-test": "new" } },
            [_vm._v("NEW")]
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "boss-vertical-menu-item-context boss-context-menu",
          class: { "is-open": _vm.isOpen },
        },
        [
          _c("div", {
            staticClass: "boss-context-menu-toggler",
            on: {
              click: function ($event) {
                $event.stopPropagation()
                return _vm.toggle.apply(null, arguments)
              },
            },
          }),
          _vm._v(" "),
          _c("div", {
            staticClass: "boss-context-menu-closer",
            on: {
              click: function ($event) {
                $event.stopPropagation()
                return _vm.close.apply(null, arguments)
              },
            },
          }),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "boss-context-menu-list" },
            [
              _vm._l(_vm.menu, function (item, key) {
                return [
                  _c(
                    "div",
                    {
                      key: key,
                      staticClass: "boss-context-menu-list-item",
                      attrs: {
                        "data-test":
                          "search-condition-" +
                          item.name +
                          "-" +
                          _vm.searchCondition.id,
                      },
                      on: {
                        click: function ($event) {
                          $event.stopPropagation()
                          item.action()
                          _vm.close()
                        },
                      },
                    },
                    [_vm._v("\n          " + _vm._s(item.title) + "\n        ")]
                  ),
                ]
              }),
            ],
            2
          ),
        ]
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "reveal boss-modal-container pega-modal-position",
          attrs: {
            id: "other-copy-modal-" + _vm.searchCondition.id,
            "data-reveal": "",
          },
        },
        [
          _c(
            "h1",
            {
              staticClass:
                "boss-page-title boss-page-title-layout-title pega-mb-25",
              attrs: { "data-test": "modal-title" },
            },
            [_vm._v("\n      検索条件を他求人にコピー\n    ")]
          ),
          _vm._v(" "),
          _c("div", { staticClass: "boss-layout boss-layout-center" }, [
            _c("div", { staticClass: "pega-bulk-update-container" }, [
              _c("div", { attrs: { "data-test": "modal-body" } }, [
                _vm._v(
                  "\n          選択した求人に" +
                    _vm._s(_vm.searchCondition.name) +
                    "の検索条件をコピー\n        "
                ),
              ]),
              _vm._v(" "),
              _c("div", [
                _c(
                  "select",
                  {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.copyToJobId,
                        expression: "copyToJobId",
                      },
                    ],
                    staticClass: "boss-input-select",
                    attrs: { "data-test": "input-select" },
                    on: {
                      change: function ($event) {
                        var $$selectedVal = Array.prototype.filter
                          .call($event.target.options, function (o) {
                            return o.selected
                          })
                          .map(function (o) {
                            var val = "_value" in o ? o._value : o.value
                            return val
                          })
                        _vm.copyToJobId = $event.target.multiple
                          ? $$selectedVal
                          : $$selectedVal[0]
                      },
                    },
                  },
                  [
                    _c(
                      "option",
                      { attrs: { "data-test": "no-selected", value: "" } },
                      [_vm._v("\n              選択してください\n            ")]
                    ),
                    _vm._v(" "),
                    _vm._l(_vm.optionJobs, function (job, i) {
                      return _c(
                        "option",
                        {
                          key: i,
                          attrs: {
                            "data-test":
                              "item-option-" +
                              _vm.searchCondition.id +
                              "-" +
                              job.id,
                          },
                          domProps: { value: job.id },
                        },
                        [
                          _vm._v(
                            "\n              " +
                              _vm._s(job.managementName) +
                              "\n            "
                          ),
                        ]
                      )
                    }),
                  ],
                  2
                ),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "text-center" }, [
                _c(
                  "button",
                  {
                    staticClass:
                      "float-center boss-button-center boss-button-large pega-button pega-mr-20",
                    attrs: {
                      disabled: !_vm.copyToJobId,
                      type: "button",
                      "data-test": "update-button",
                    },
                    on: {
                      click: function ($event) {
                        $event.stopPropagation()
                        return _vm.otherJobCopy.apply(null, arguments)
                      },
                    },
                  },
                  [_vm._v("\n            コピーする\n          ")]
                ),
                _vm._v(" "),
                _c(
                  "button",
                  {
                    staticClass:
                      "float-center boss-button-center boss-button-large",
                    attrs: { type: "button", "data-test": "cancel-button" },
                    on: {
                      click: function ($event) {
                        $event.stopPropagation()
                        return _vm.closeReveal()
                      },
                    },
                  },
                  [_vm._v("\n            キャンセル\n          ")]
                ),
              ]),
            ]),
          ]),
          _vm._v(" "),
          _c("button", {
            staticClass: "close-button boss-close-button boss-icon-cross",
            attrs: {
              "data-close": "",
              "aria-label": "Close modal",
              type: "button",
            },
            on: {
              click: function ($event) {
                $event.stopPropagation()
                return _vm.closeReveal()
              },
            },
          }),
        ]
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }